export function moneyFormat(n) {
  const amount = parseFloat(n);
  const formattedAmount = amount.toFixed(2);
  const parts = formattedAmount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${parts.join('.')}`;
}
